import { render, staticRenderFns } from "./classDetails.vue?vue&type=template&id=159f2740&scoped=true"
import script from "./classDetails.vue?vue&type=script&lang=js"
export * from "./classDetails.vue?vue&type=script&lang=js"
import style0 from "./classDetails.vue?vue&type=style&index=0&id=159f2740&prod&lang=less&scoped=true"
import style1 from "./classDetails.vue?vue&type=style&index=1&id=159f2740&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159f2740",
  null
  
)

export default component.exports